import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DbService } from '../services/db.service';

export const shipmentGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const dbService = inject(DbService);

  try {
    const shipments = await dbService.getShipments();

    if (!shipments || shipments.length === 0) {
      router.navigate(['/home']);
      return false;
    }
  } catch (error) {
    console.error('Error checking shipments:', error);
    router.navigate(['/home']);
    return false;
  }

  return true;
};
